import { URL_BASE_ACCESOCLIENTES } from "../../constants/url";
import { composeErrorNotification } from "../../utils/composeNotification";
import { get, post, postGetFile } from "../../utils/fetch";
import { types } from "../types/types";
import { notification } from "./notificationActions";

export const startGetAsistencias = (fechaInicio = null, fechaFin = null) => {
  return async (dispatch) => {
    if (!fechaInicio || !fechaFin) return;

    dispatch(setLoadingList(true));
    dispatch(setUltimasFechas({ fechaInicio, fechaFin }));

    const url = `${URL_BASE_ACCESOCLIENTES}/GetAsistencias`;
    const body = { fechaInicio, fechaFin };

    const result = await post(url, body);
    if (result.code === 0) {
      dispatch(storeAsistencias(result.data));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Get asistencias",
            `${result.error}`
          )
        )
      );
    }
    dispatch(setLoadingList(false));
  };
};

const storeAsistencias = (asistencias) => ({
  type: types.storeAsistencias,
  payload: asistencias,
});

////////////////////////

export const startGetAsistencia = (asistenciaID) => {
  return async (dispatch) => {
    //
    dispatch(setLoadDetalle(true));
    const url = `${URL_BASE_ACCESOCLIENTES}/GetAsistencia/${asistenciaID}`;

    const result = await get(url);
    if (result.code === 0) {
      dispatch(storeAsistencia(result.data));
    } else {
      dispatch(
        notification(
          composeErrorNotification(
            "Error de conexion - Get asistencia",
            `${result.error}`
          )
        )
      );
    }
    //
    dispatch(setLoadDetalle(false));
  };
};

const setLoadDetalle = (estado) => ({
  type: types.setLoadingDetalle,
  payload: estado,
});

const storeAsistencia = (asistencia) => ({
  type: types.storeAsistencia,
  payload: asistencia,
});


//  Get File
export const startGetAsistenciasXls = (body) => {
  return async (dispatch) => {
    //
    dispatch(setLoadDetalle(true));
    const url = `${URL_BASE_ACCESOCLIENTES}/GetAsistenciasXls/`;

    const result = await postGetFile(url, body);

    if(!result.ok)
      dispatch(
        notification(
          composeErrorNotification(
            "startGetAsistenciasXls",
            `${result.error}`
          )
        )
      );

  };
};

const setUltimasFechas = (fechas) => ({
  type: types.setUltimasFechas,
  payload: fechas,
});

const setLoadingList = (estado) => ({
  type: types.setLoadingList,
  payload: estado,
});